if (!customElements.get("social-media-highlights-slider")) {
  class SocialMediaHighlightsSlider extends HTMLElement {
    constructor() {
      super();

      const swiperOptions = JSON.parse(this.getAttribute('data-swiper-options')) || {};

      this.sliderItem = this.querySelector('.swiper');

      this.sliderOptions = {
        loop: true,
        slidesPerView: 1,
        spaceBetween: swiperOptions.spaceBetweenMobile || 0,
        breakpoints: {
          750: {
            slidesPerView: swiperOptions.slidesPerViewDesktop || 3,
            spaceBetween: swiperOptions.spaceBetweenDesktop || 0
          },
          1100: {
            slidesPerView: swiperOptions.slidesPerViewDesktop || 4,
            spaceBetween: swiperOptions.spaceBetweenDesktop || 0
          }
        },
        on: {
          afterInit: () =>
            this.querySelector(".swiper-smh").removeAttribute("style")
        }
      };

      if (swiperOptions.autoplaySpeed !== 0) {
        this.sliderOptions = {
          speed: swiperOptions.autoplaySpeed || 10000,
          autoplay: {
            delay: 0,
            disableOnInteraction: false,
            pauseOnMouseEnter: true
          },
          ...this.sliderOptions
        };
      }

      if (Shopify.designMode) {
        window.addEventListener('shopify:section:load', this.init.bind(this));
      }
    }

    connectedCallback() {
      this.init();
    }

    init() {
      this.swiper = new Swiper(this.sliderItem, this.sliderOptions);
    }
  }

  customElements.define("social-media-highlights-slider", SocialMediaHighlightsSlider);
}
